// Analytics events for ACCESS Registration
// Following Mixpanel naming convention: lowercase_with_underscores

// ============ SCREEN VIEWS ============
// Fired when user views a screen
export const VIEW_WELCOME = 'welcome_access';
export const VIEW_COVERAGE = 'coverage_access';
export const VIEW_NOT_ELIGIBLE = 'not_eligible_access';
export const VIEW_CAP_REACHED = 'cap_reached_access';
export const VIEW_GATING_ECKM = 'gating_eckm_access';
export const VIEW_GATING_CKM = 'gating_ckm_access';
export const VIEW_GATING_BH = 'gating_bh_access';
export const VIEW_PROGRAM = 'program_access';
export const VIEW_SIGNUP = 'signup_access';
export const VIEW_DOWNLOAD_APP = 'download_app_access';
export const VIEW_CHECK_SMS = 'check_sms_access';
export const VIEW_DOWNLOAD_APP_QR = 'download_app_qr_access';
export const VIEW_EMAIL_SAVED = 'email_saved_access';
export const VIEW_ALREADY_REGISTERED = 'already_registered_access';

// ============ BUTTON / CTA PRESSED ============
export const START_WEBREG = 'start_webreg_access';
export const CONTINUE_WEBREG = 'continue_webreg_access';
export const NEED_HELP = 'need_help_access';
export const GET_NOTIFIED = 'get_notified_access';

// Sign up page
export const SUBMIT_SIGNUP = 'submit_signup_access';

// Download app page
export const DOWNLOAD_APP = 'download_app_access';
export const DOWNLOAD_LINK_INVOKED = 'download_link_invoked_access';
export const DOWNLOAD_OTP_LINK_INVOKED = 'download_otp_link_invoked_access';

// Check SMS page
export const CHECK_SMS_TRY_AGAIN = 'check_sms_try_again_access';

// QR Code page
export const TEXT_ME_LINK = 'text_me_link_access';

// ============ HEADER INTERACTIONS ============
export const CHANGE_LANGUAGE = 'change_language_access';
export const LANGUAGE_CHANGED = 'language_changed_access';

// ============ SUPPORT MODAL ============

export const POPUP_VIEW_SUPPORT = 'support_access';

export const EMAIL_SUPPORT = 'email_support_access';
export const CALL_SUPPORT = 'call_support_access';
export const SUPPORT_CLOSE = 'support_close_access';
export const CHATBOT = 'chatbot_access';

// ============ START OVER MODAL ============
export const CANCEL_START_OVER = 'web_startover_cancel_access';
export const CONFIRM_START_OVER = 'web_startover_confirm_access';

// ============ API ERROR MODAL ============
export const POPUP_API_ERROR = 'api_error_access';

// ============ REGISTRATION OUTCOMES ============
export const REGISTRATION_SUCCESS = 'registration_successful_access';
export const REGISTRATION_FAILED = 'registration_failed_access';
export const ENROLLMENT_CAP_REACHED = 'enrollment_cap_reached_access';
export const ALIGNMENT_FAILED = 'alignment_failed_access';
// RND-36355: alignment result polling outcomes (emitted from PasswordAccountForm).
export const ALIGNMENT_COMPLETE = 'alignment_complete_access';
export const ALIGNMENT_TIMEOUT = 'alignment_timeout_access';

// ============ SHIPPING PAGE ============
export const VIEW_SHIPPING = 'shipping_access';
export const SHIPPING_SUBMIT = 'shipping_submit_access';

// ============ PHQ-9 / GAD-7 BH SCREENER (RND-35692) ============
// PHI NOTE: raw PHQ-9/GAD-7 scores and the Q9 response are intentionally NOT
// emitted as event properties (Daniel flagged raw scores as PHI exposure). Only
// booleans + non-PHI resource ids are sent. Restore the score/q9_response props
// from PRD 11 §6 / Tech Design §12 once the PHI review clears.
// TODO(RND-35692): restore raw score props once PHI review clears (Daniel).
export const VIEW_PHQ9_SCREENER = 'phq9_screener_access';
export const VIEW_GAD7_SCREENER = 'gad7_screener_access';
export const PHQ9_SCREENER_COMPLETED = 'phq9_screener_completed_access';
export const GAD7_SCREENER_COMPLETED = 'gad7_screener_completed_access';
export const CRISIS_GATE_SHOWN = 'crisis_gate_shown_access';
export const CRISIS_RESOURCE_CLICKED = 'crisis_resource_clicked_access';
export const BH_TRACK_DROPPED_THRESHOLD = 'bh_track_dropped_threshold_access';

// MISC
export const ERROR_EVENT_NAME = 'access_error';

// ============ ERROR EVENTS ============
export const ERROR_API_CALL = 'error_api_call_access';
export const RECAPTCHA_VALIDATION_FAILED = 'recaptcha_failed_access';
export const ERROR_ENCRYPTION_FAILED = 'error_encryption_failed_access';
export const ERROR_DECRYPTION_FAILED = 'error_decryption_failed_access';
export const ERROR_STORAGE_SAVE_FAILED = 'error_storage_save_failed_access';
export const ERROR_STORAGE_LOAD_FAILED = 'error_storage_load_failed_access';
export const VIEW_ELIGIBILITY_RESULT = 'view_eligibility_result_access';
